import { combineReducers } from 'redux';
import flags from '../shared/flags';
import appticker from '../appticker';
import roadblock from '../roadblock';
import footer from '../shared/footer';
import search from '../shared/search';
import grid from '../shared/grid';
import gridPDP from '../shared/gridPDP';

// todo: check usgae of request
import request from '../shared/request';
import requestPDP from '../shared/requestPDP';
import modals from '../shared/modal';
import httpError from '../shared/HTTPError';
import popup from '../shared/Popup';
import cart from '../../cart/reducers/cart';
import edd from '../../edd/reducers/index';
import loaders from '../shared/loaders';
import product from '../shared/product';
import location from '../shared/location';
import webMetaData from '../shared/webMetaData';
import networkStatus from '../shared/networkStatus';
import recentlyViewed from '../shared/recentlyViewed';
import RecentSearches from '../shared/recentSearch';
import productsAdditionalInfo from '../shared/productsAdditionalInfo';
import bannerInfo from '../../myaccount/reducers/bannerInfo';
import counter from '../shared/counter';
import referAndEarn from '../../myaccount/reducers/referAndEarn';
import banner from '../shared/banner';
import bannerProducts from '../bannerProducts';
import ratingsReducers from '../shared/ratings';
import wishlist from '../../wishlist/reducers/wishlist';
import cacheData from '../shared/cacheData';
import membershipReducer from '../shared/membershipReducer';
import minicart from '../shared/minicart';
import {stepsReducer , apiCallReducer, dressToolFlagReducer} from '../../reducers/shared/braRecommendation';
import addressBook from '../../myaccount/reducers/addressBook';
import ajioWalletData from '../../myaccount/reducers/ajioWalletData';
import { miscellaneousReducer } from '../shared/miscellaneous';
import cmsAdsReducer from '../shared/cmsAdsReducer';
import { rushAddressBarFlagReducer, rushDeliveryTypeReducer } from '../shared/ajioRush';
import ajioWalletDataBottomStrip from '../shared/ajioWalletDataBottomStrip';
import recommendationWidgetReducer from '../shared/recommendationWidget';
import variants from '../shared/variants';
import mobileBottomNavReducer from './mobileBottomNavReducer';

const rootReducer = combineReducers({
  metaData: webMetaData,
  productsAdditionalInfo,
  recentlyViewed,
  RecentSearches,
  networkStatus,
  appticker,
  roadblock,
  location,
  popup,
  cart,
  edd,
  loaders,
  search,
  request,
  requestPDP,
  httpError,
  product,
  footer,
  flags,
  bannerInfo,
  counter,
  referAndEarn,
  grid,
  gridPDP,
  banner,
  bannerProducts,
  modals,
  ratings: ratingsReducers,
  wishlist,
  cacheData,
  membership: membershipReducer,
  minicart,
  stepsReducer,
  apiCallReducer,
  dressToolFlagReducer,
  addressBook,
  miscellaneous: miscellaneousReducer,
  cmsAds: cmsAdsReducer,
  rushAddressBarFlagReducer,
  rushDeliveryTypeReducer,
  ajioWalletData,
  ajioWalletDataBottomStrip,
  recommendationWidget: recommendationWidgetReducer,
  widgets: recommendationWidgetReducer,
  variants,
  bottomNavList: mobileBottomNavReducer
});

export default rootReducer;
